import { PaymentProcessorStatus } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/constants";

interface PaymentProcessor {
  is_restricted_for_application_fees: boolean;
  status: string;
}

export const STATUS = Object.freeze({
  RESTRICTED: "restricted",
  PENDING: "pending",
  REJECTED: "rejected",
  ENABLED: "enabled",
} as const);

export const PAYMENT_PROCESSORS = Object.freeze({
  STRIPE_US: "CommunityPaymentProcessors::StripeUnitedStates",
  STRIPE_BR: "CommunityPaymentProcessors::StripeBrazil",
  REVENUE_CAT: "CommunityPaymentProcessors::RevenueCat",
} as const);

type PaymentProcessorStatusValues =
  (typeof PaymentProcessorStatus)[keyof typeof PaymentProcessorStatus];

export const paymentProcessorValidations = (
  paymentProcessor: PaymentProcessor | null | undefined,
): (() => PaymentProcessorStatusValues | undefined)[] => [
  (): PaymentProcessorStatusValues | undefined =>
    !paymentProcessor ? PaymentProcessorStatus.NOT_EXIST : undefined,
  (): PaymentProcessorStatusValues | undefined =>
    paymentProcessor?.status === STATUS.RESTRICTED
      ? PaymentProcessorStatus.RESTRICTED
      : undefined,
  (): PaymentProcessorStatusValues | undefined =>
    paymentProcessor?.is_restricted_for_application_fees
      ? PaymentProcessorStatus.RESTRICTED_FOR_APPLICATION_FEES
      : undefined,
  (): PaymentProcessorStatusValues | undefined =>
    paymentProcessor?.status === STATUS.PENDING
      ? PaymentProcessorStatus.PENDING
      : undefined,
  (): PaymentProcessorStatusValues | undefined =>
    paymentProcessor?.status === STATUS.REJECTED
      ? PaymentProcessorStatus.REJECTED
      : undefined,
];

export const hasRevenueCatPaymentProcessor = (
  paymentProcessors: string[] | null | undefined,
): boolean =>
  paymentProcessors?.includes(PAYMENT_PROCESSORS.REVENUE_CAT) ?? false;

export const isEnabled = (
  paymentProcessorStatus: PaymentProcessorStatusValues,
): boolean => paymentProcessorStatus === PaymentProcessorStatus.ENABLED;
